import React, {useState, useEffect} from 'react';
import httpService from "../../../services/http.service";
import queryString from "query-string";
import AppBreadcrumb from "../../Shared/AppBreadcrumb";
import {useFormik} from "formik";
import AppInput from "../../Shared/AppInput";
import AppSelect from "../../Shared/AppSelect";
import FecthingSpinner from "../../Shared/FecthingSpinner";
import MyOpinionLogo from "../../../assets/images/MyOpinion_Logo_Head.png";
import {MONTH, VERIFIED} from "../../../utils/index";
import AppPagination from "../../Shared/AppPagination";

const SubscriptionList = ({history, location, match, ...props}) => {

    const query = queryString.parse(location.search);

    const initialValues = {
        subscr_type: query?.subscr_type || '',
        page: query?.page || 1
    };

    const [fetching, setFetching] = useState(true);
    const [subscriptions, setSubscriptions] = useState([]);
    const [subscriptionTypes, setSubscriptionTypes] = useState([]);
    const [paginationData, setPaginationData] = useState({
        currentPage:  query?.page || 1,
        lastPage: Infinity,
        hasNext: true,
        hasPrevious: false,
        totalItems: Infinity
    });

    const fetchSubscriptionTypes = async (cb = () => null) => {
        const {data: response} = await httpService.get(`/subscription_types`);
        cb(response);
        return response;
    }

    const fetchSubscriptions = async (params = {}, cb = () => null) => {
        const { data: response } = await httpService.get(`/subscriptions`, {
            params
        });
        setSubscriptions(response.data);
        setPaginationData(state => ({
            ...state,
            currentPage: response?.meta?.current_page,
            lastPage: response?.meta?.last_page,
            totalItems: response?.meta?.total,
            hasNext: !!response?.links?.next,
            hasPrevious: !!response?.links?.prev
        }));
        cb();
    };

    const onSubmit = async (values) => {

        setFetching(true);

        const data = {
            ...initialValues,
            ...values,
            page: 1
        };

        history.push(`/subscriptions?${queryString.stringify(data)}`);

    };

    const onReset = () => {
        formik.resetForm({
            subscr_type: '',
            page: 1,
        });

        history.push(`/subscriptions`);
    }

    const handlePagePaginate = async (direction) => {

        let page = parseInt(query?.page || 1);

        const nextPage = direction === 'previous' ? --page : ++page;

        const data = {
            subscr_type: query.subscr_type || '',
            page: nextPage
        };

        history.push(`/subscriptions?${queryString.stringify(data)}`);

    }

    useEffect(() => {
        setFetching(true);

        try {

            fetchSubscriptions({
                subscr_type: query.subscr_type || '',
                page: query.page || 1,
            }, () => {
                fetchSubscriptionTypes((types) => {
                    setSubscriptionTypes(types);
                    setFetching(false);
                });
            });

        } catch (e) {
            throw e;
        }

    }, [
        query.subscr_type,
        query.page,
    ]);

    const formik = useFormik({
        initialValues,
        onSubmit
    });

    return (
        <div className="container-fluid">
            <AppBreadcrumb title="Abonnements Gold & Premium en cours" />

            <div className="row clearfix">
                <div className="col-md-12">
                    <div className="card border shadow-sm">
                        <form onSubmit={formik.handleSubmit}>
                            <div className="card-header bg-info text-white font-weight-bold">
                                <i className="fa fa-search"></i>{' '}
                                <span>Filtre de recherche</span>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <AppSelect
                                            name="subscr_type"
                                            placeholder="Selectionnez le type d'abonnement"
                                            value={formik.values.subscr_type}
                                            onChange={formik.handleChange}
                                        >
                                            {subscriptionTypes.map(obj => (
                                                <option selected={obj?.value === formik.values.subscr_type} key={obj?.value} value={obj?.value}>{obj?.label}</option>
                                            ))}
                                        </AppSelect>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer bg-white text-right">
                                <button type="button" onClick={onReset} className="btn btn-danger mr-1">
                                    <i className="fa fa-times"></i>{' '}
                                    <span className="font-weight-bold">Annuler</span>
                                </button>
                                <button type="submit" className="btn btn-success">
                                    <i className="fa fa-check"></i>{' '}
                                    <span className="font-weight-bold">Rechercher</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {fetching ? <FecthingSpinner /> : (
                <div className="row clearfix">
                    <div className="col-md-12">
                        <div className="table-responsive">
                            <table className="table table-hover table-custom spacing8">
                                <thead>
                                <tr>
                                    <th>Photo</th>
                                    <th>Utilisateur</th>
                                    <th>Pays</th>
                                    <th className="text-center">Type d'abonnement</th>
                                    <th className="text-center">Prix (USD)</th>
                                    <th>Durée</th>
                                    <th>Période</th>
                                </tr>
                                </thead>
                                <tbody>
                                {subscriptions.map(obj => (
                                    <tr key={obj?.subscr_id}>
                                        <td className="w60">
                                            <img src={obj?.user?.profile?.prof_picture || MyOpinionLogo} data-toggle="tooltip"
                                                 data-placement="top" title="Avatar Name" alt="Avatar"
                                                 className="w35 rounded"/>
                                        </td>
                                        <td>
                                            {`${obj?.user?.user_surname} ${obj?.user?.user_name}`} (@{obj?.user?.user_username}){' '}
                                        </td>
                                        <td>
                                            <span>{obj?.user?.user_ip_pays || '-'}</span>
                                        </td>
                                        <td className="text-center">
                                            {obj?.subscr_type === VERIFIED
                                                ? <i style={{cursor: 'pointer'}} title="Verified" className="fa fa-check-circle-o fa-2x text-primary"/>
                                                : <i style={{cursor: 'pointer'}} title="Premium / Gold" className="fa fa-star fa-2x text-warning"/>}
                                        </td>
                                        <td className="text-center">
                                            {obj?.subscr_price === 0 ? (<span className="badge badge-success  ml-0 mr-0">Gratuit</span>) : Number.parseFloat(obj?.subscr_price).toFixed(2) + ' USD'}
                                        </td>
                                        <td>
                                            {obj?.subscr_period === MONTH ? '1 Mois' : '1 an'}
                                        </td>
                                        <td>
                                            Du {obj?.subscr_start_at} au {obj?.subscr_ends_at}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="card">
                            <div className="body">
                                <AppPagination
                                    onNavigate={handlePagePaginate}
                                    currentPage={paginationData.currentPage}
                                    hasNext={paginationData.hasNext}
                                    hasPrevious={paginationData.hasPrevious}
                                    totalItems={paginationData.totalItems}
                                    lastPage={paginationData.lastPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )

}

export default SubscriptionList;